module.exports = __webpack_public_path__ + "img/13-1_03.76734aba.jpg";